import useAuth from "hooks/useAuth";
import {
  canAccessAdminPanel,
  canDelete,
  canPublish,
  canManageSubAdmins,
  isFullAdmin,
  isSubAdmin,
} from "utils/adminAccess";

/**
 * Admin panel permissions derived from user.role only.
 * Full admin: all actions. Sub-admin: panel access, no delete/publish.
 */
export default function useAdminPermissions() {
  const { user } = useAuth();

  return {
    user,
    isFullAdmin: isFullAdmin(user),
    isSubAdmin: isSubAdmin(user),
    canAccessAdmin: canAccessAdminPanel(user),
    canDelete: canDelete(user),
    canPublish: canPublish(user),
    canManageSubAdmins: canManageSubAdmins(user),
  };
}
